import { useCallback } from "react";

/**
 * Detects if the current page is an OAuth callback and provides
 * the effect to relay auth code back to the opener window.
 */
export function useAuthCallback(redirectPath: string) {
  const currentPath = window.location.pathname;
  const isAuthCallback = currentPath === redirectPath;

  const authCallbackEffect = useCallback(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("code");
    const error = urlParams.get("error");
    const state = urlParams.get("state");

    if (window.opener) {
      window.opener.postMessage(
        { type: "CASDOOR_AUTH_CALLBACK", code, error, state },
        window.location.origin,
      );
      setTimeout(() => window.close(), 100);
    }
  }, []);

  return { isAuthCallback, authCallbackEffect };
}
